import script from "./ComHakuResultDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComHakuResultDetails.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__